import {X, Trash2, Heart} from "lucide-react";
import {sized} from "@/lib/utils";

export default function WishlistModal({close, listings, wishlist, toggleWishlist, notify}) {
  const items = listings.filter(l => wishlist.includes(l.listing_id));
  return (
    <div className="modal-backdrop" onClick={close}>
      <div className="basket-sheet" data-testid="wishlist-page" onClick={e => e.stopPropagation()}>
        <button className="basket-close" data-testid="wishlist-close" onClick={close}><X size={18}/></button>
        <div className="eyebrow">WISHLIST</div>
        <h2>Favourites</h2>
        <p className="modal-sub">{items.length ? `${items.length} business${items.length > 1 ? "es" : ""} you're keeping an eye on.` : "You haven't wishlisted anything yet. Tap the heart on any business to add it here."}</p>
        <div className="basket-items">
          {items.map(x => (
            <div className="basket-item-detailed" key={x.listing_id} data-testid={`wishlist-item-${x.listing_id}`}>
              <img src={sized(x.image, 240)} alt={x.name} loading="lazy" decoding="async"/>
              <div className="basket-item-body">
                <strong>{x.name}</strong>
                <small>{x.category} · {x.location}</small>
                <p>{x.description}</p>
              </div>
              <button data-testid={`wishlist-remove-${x.listing_id}`} className="basket-remove-btn" onClick={() => { toggleWishlist(x.listing_id); notify("Removed from wishlist"); }}>
                <Trash2 size={14}/>
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
